import React, { Component } from 'react'
import './home.css'
import Swiper from 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'
import NavArr from '../handf/nav.json'
import Photo from '../handf/photo.json'
import Footer from '../handf/Footer'
import { get, post } from '../../ajax/tools'
import PopUp from '../round/PopUp'

class GS extends Component {
  constructor(props) {
    super(props)
    this.state = {
      GSPage: 0,

      PhotoArr: [],
      NewsArr: [],
      new: '',
      newLength: '',
      newInfo: {},
      newIndex: '',
      XQNewsArr: [],

      YearArr: [],
      Year: '',

      NewContent: '',
      title: '',
    }
  }
  componentDidMount = function () {
    let Route = this.props.location.search
    let ThreeIndex = Route.lastIndexOf('?') //'_'最后出现的位置
    if (ThreeIndex === -1) {
      this.setState({
        GSPage: 0,
      })
    } else {
      let sb = Route.substring(ThreeIndex + 1)
      get({ url: 'match/show_match_news_info/' + Number(sb) }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          this.setState({
            NewContent: data.content,
            title: data.title,
          })
          let XQYear = data.rank_time.substring(0, 4)
          // console.log(XQYear)
          post({
            url: 'match/show_match_news',
            data: {
              match_year: XQYear,
              match_type: 1,
            },
          }).then((res) => {
            if (res.errno === '200') {
              let dsb = function () {
                for (let i = 0; i < res.data.length; i++) {
                  let a = res.data[i].id
                  if (a === Number(sb)) {
                    return i
                  }
                }
              }
              this.setState({
                XQNewsArr: res.data,
                newIndex: dsb(),
              })
            }
          })
        } else {
          this.setState({
            NewContent: '',
          })
        }
      })
      this.setState({
        GSPage: Number(sb),
      })
    }

    let date = new Date()
    let ToDayYear = date.getFullYear()
    let Year = function () {
      const Years = []
      for (let i = ToDayYear; i > 2018; i--) {
        Years.push(i)
      }
      return Years
    }
    this.setState({
      YearArr: Year(),
      Year: ToDayYear,
    })
    post({
      url: 'match/show_match_news',
      data: {
        match_year: ToDayYear,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200') {
        if (res.data.length > 5) {
          let SB = function () {
            let SBs = []
            for (let i = 0; i < 6; i++) {
              SBs.push(res.data[i])
            }
            return SBs
          }
          this.setState({
            NewsArr: SB(),
            new: '1',
          })
        } else {
          this.setState({
            NewsArr: res.data,
            new: '1',
          })
        }
        this.setState({
          newLength: res.data.length,
        })
      } else {
        this.setState({
          NewsArr: [],
          new: '2',
        })
      }
    })

    for (let i = 0; i < Photo.length; i++) {
      let a = Photo[i].year
      if (a === ToDayYear) {
        this.setState({
          PhotoArr: Photo[i].data,
        })
      }
    }

    window.onscroll = function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let AllHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      // console.log("滚动距离" + scrollTop);
      // console.log(AllHeight - scrollTop);
      // 计算滚动条长度的函数
      let sb = document.querySelector('.YJBackTop')
      if (sb) {
        if (scrollTop > 450) {
          document.querySelector('.YJBackTop').style.display = 'block'
        } else {
          document.querySelector('.YJBackTop').style.display = 'none'
        }
        if (AllHeight - scrollTop > 500) {
          document.querySelector('.YJBackTop').style.position = 'fixed'
          document.querySelector('.YJBackTop').style.bottom = '100px'
        } else {
          document.querySelector('.YJBackTop').style.position = 'absolute'
          document.querySelector('.YJBackTop').style.bottom = '600px'
        }
      }
    }
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {}
  }

  componentDidUpdate() {
    //Swiper的Js
    let a = this.state.GSPage
    if (a === 0) {
      this.swiper = new Swiper('.swiper-container', {
        loop: false, //循环
        slidesPerView: 3, //展示几个
        centeredSlides: true, //设置了Active Slide居中
        centeredSlidesBounds: true, //第一个和最后一个Slide 始终贴合边缘
        width: 800, //你的slide宽度
        height: 185, //你的slide高度
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }
  }

  UNSAFE_componentWillUpdate() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  NavListClick = (item, index) => {
    const { history } = this.props
    history.push(item.router)
    let date = new Date()
    let ToDayYear = date.getFullYear()
    this.setState({
      PhotoArr: [],
      NewsArr: [],
      new: '',
      newLength: '',
      newInfo: {},
      newIndex: '',
      XQNewsArr: [],
      GSPage: 0,
      Year: ToDayYear,
    })
    post({
      url: 'match/show_match_news',
      data: {
        match_year: ToDayYear,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200') {
        if (res.data.length > 5) {
          let SB = function () {
            let SBs = []
            for (let i = 0; i < 6; i++) {
              SBs.push(res.data[i])
            }
            return SBs
          }
          this.setState({
            NewsArr: SB(),
            new: '1',
          })
        } else {
          this.setState({
            NewsArr: res.data,
            new: '1',
          })
        }
        this.setState({
          newLength: res.data.length,
        })
      } else {
        this.setState({
          NewsArr: [],
          new: '2',
        })
      }
    })

    for (let i = 0; i < Photo.length; i++) {
      let a = Photo[i].year
      if (a === ToDayYear) {
        this.setState({
          PhotoArr: Photo[i].data,
        })
      }
    }
  }

  YearClick = (item, index) => {
    this.setState({ PhotoArr: [], new: '' })
    post({
      url: 'match/show_match_news',
      data: {
        match_year: item,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200') {
        if (res.data.length > 5) {
          let SB = function () {
            let SBs = []
            for (let i = 0; i < 6; i++) {
              SBs.push(res.data[i])
            }
            return SBs
          }
          this.setState({
            NewsArr: SB(),
            new: '1',
          })
        } else {
          this.setState({
            Year: item,
            NewsArr: res.data,
            new: '1',
          })
        }
        this.setState({
          newLength: res.data.length,
          Year: item,
        })
      } else {
        this.setState({
          Year: item,
          NewsArr: [],
          new: '2',
        })
      }
    })

    for (let i = 0; i < Photo.length; i++) {
      let a = Photo[i].year
      if (a === item) {
        this.setState({
          PhotoArr: Photo[i].data,
        })
      }
    }
  }

  NewClick = (item, index) => {
    if (item.is_pdf && item.is_pdf === 1) {
      get({ url: 'match/show_match_news_info/' + item.id }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          window.open(data.content)
        }
      })
    } else {
      let sb = this.state.Year
      this.setState({ NewContent: '' })
      const { history } = this.props
      history.push('/gs?' + item.id)
      get({ url: 'match/show_match_news_info/' + item.id }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          this.setState({
            NewContent: data.content,
            title: data.title,
          })
        } else {
          this.setState({
            NewContent: '',
          })
        }
      })
      post({
        url: 'match/show_match_news',
        data: {
          match_year: sb,
          match_type: 1,
        },
      }).then((res) => {
        if (res.errno === '200') {
          this.setState({
            XQNewsArr: res.data,
          })
        }
      })
      this.setState({
        GSPage: 1,
        newInfo: item,
        newIndex: index,
      })
    }
  }

  GSXQLink1() {
    let sb = this.state.XQNewsArr[this.state.newIndex - 1].id
    let dsb = this.state.XQNewsArr[this.state.newIndex - 1]
    if (dsb.is_pdf && dsb.is_pdf === 1) {
      get({ url: 'match/show_match_news_info/' + sb }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          window.open(data.content)
        }
      })
    } else {
      this.setState({ NewContent: '' })
      const { history } = this.props
      history.push('/gs?' + sb)
      get({ url: 'match/show_match_news_info/' + sb }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          this.setState({
            NewContent: data.content,
            title: data.title,
            newIndex: this.state.newIndex - 1,
          })
        }
      })
    }
  }

  GSXQLink2() {
    let sb = this.state.XQNewsArr[this.state.newIndex + 1].id
    let dsb = this.state.XQNewsArr[this.state.newIndex + 1]
    if (dsb.is_pdf && dsb.is_pdf === 1) {
      get({ url: 'match/show_match_news_info/' + sb }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          window.open(data.content)
        }
      })
    } else {
      this.setState({ NewContent: '' })
      const { history } = this.props
      history.push('/gs?' + sb)
      get({ url: 'match/show_match_news_info/' + sb }).then((res) => {
        if (res.errno === '200') {
          let data = res.data[0]
          this.setState({
            NewContent: data.content,
            title: data.title,
            newIndex: this.state.newIndex + 1,
          })
        }
      })
    }
  }

  LookPhoto = (item, index) => {
    window.open(item.url)
  }

  LookMore() {
    let sb = this.state.Year
    post({
      url: 'match/show_match_news',
      data: {
        match_year: sb,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          NewsArr: res.data,
          new: '1',
          newLength: res.data.length,
        })
      } else {
        this.setState({
          NewsArr: [],
          new: '2',
        })
      }
    })
  }

  GSBack() {
    const { history } = this.props
    history.push('/gs')
    this.setState({
      XQNewsArr: [],
      GSPage: 0,
    })
  }

  BackTop = () => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    })
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'Home'}>
        {/*背景*/}
        {/*菜单*/}
        <div
          className={'HomeNavTopBox'}
          style={{ position: 'relative', background: '#00479D' }}
        >
          <div className={'NavTopBox'}>
            <div className={'HomeLogoBox'}>
              <img
                className={'HomeLogo'}
                src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
                alt=""
              />
            </div>
            <div className={'NavTop clearfix'}>
              {NavArr.map((item, index) => (
                <div
                  className={'NavTopList'}
                  key={index}
                  onClick={() => this.NavListClick(item, index)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/*列表*/}
        {this.state.GSPage === 0 && (
          <div className={'GSBox clearfix'}>
            {/*年份选择*/}
            <div className={'YearBox scrollBarTwo'}>
              {this.state.YearArr.map((item, index) => (
                <div
                  className={'YearList'}
                  key={index}
                  onClick={() => this.YearClick(item, index)}
                  style={
                    this.state.Year === item
                      ? { color: '#00479D' }
                      : { color: '#000' }
                  }
                >
                  <div
                    className={'YearListIco'}
                    style={
                      this.state.Year === item
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {' '}
                  </div>
                  {item}年
                </div>
              ))}
            </div>
            {/*国赛资讯*/}
            <div className={'GSZXBox'}>
              <div className={'GSZXTit'}>国赛资讯</div>
              <div className={'GSZXBor'}> </div>
              <div className={'GSZXMain'}>
                {this.state.new === '1' && (
                  <div>
                    {this.state.NewsArr.map((item, index) => (
                      <div
                        className={'GSZXMainList'}
                        key={index}
                        onClick={() => this.NewClick(item, index)}
                      >
                        <div className={'GSZXMainW Ellipsis'}>{item.title}</div>
                        <div className={'GSZXMainTime'}>
                          {item.rank_time === ''
                            ? this.state.Year + ' / 03 / 16'
                            : item.rank_time.split('-').join(' / ')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {this.state.new === '2' && (
                  <div className={'GSZXMainList'} style={{ cursor: 'unset' }}>
                    <div className={'GSZXMainW Ellipsis'}>暂无数据。</div>
                  </div>
                )}
              </div>
              <div className={'LookMore'}>
                {this.state.NewsArr.length === 6 && (
                  <div onClick={this.LookMore.bind(this)}>查看更多</div>
                )}
              </div>
              <div id={'GSbBanner'}>
                <div className={'swiper-container'}>
                  {this.state.PhotoArr.length !== 0 && (
                    <div className={'swiper-wrapper swiper-no-swiping'}>
                      {this.state.PhotoArr.map((item, index) => (
                        <div className={'swiper-slide'} key={index}>
                          <img
                            className={'BannerImage'}
                            src={item.url}
                            alt={''}
                            onClick={() => this.LookPhoto(item, index)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {this.state.PhotoArr.length !== 0 && (
                  <div>
                    <div className="swiper-button-next"> </div>
                    <div className="swiper-button-prev"> </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/*详情*/}
        {this.state.GSPage !== 0 && (
          <div className={'GSXQBox'}>
            <div className={'GSXQTit'}>
              首页 /{' '}
              <span
                style={{ cursor: 'pointer' }}
                onClick={this.GSBack.bind(this)}
              >
                国赛资讯
              </span>{' '}
              / 资讯详情
            </div>
            <div className={'GSXQMain'}>
              <div
                dangerouslySetInnerHTML={{ __html: this.state.NewContent }}
              />
            </div>
            {this.state.newIndex !== '' &&
              this.state.newIndex !== 0 &&
              this.state.XQNewsArr[this.state.newIndex - 1] && (
                <div className={'YJLink'}>
                  <span onClick={this.GSXQLink1.bind(this)}>
                    上一篇：
                    {this.state.XQNewsArr[this.state.newIndex - 1].title}
                  </span>
                </div>
              )}
            {this.state.newIndex !== '' &&
              this.state.newIndex !== this.state.XQNewsArr.length &&
              this.state.XQNewsArr[this.state.newIndex + 1] && (
                <div className={'YJLink'}>
                  <span onClick={this.GSXQLink2.bind(this)}>
                    下一篇：
                    {this.state.XQNewsArr[this.state.newIndex + 1].title}
                  </span>
                </div>
              )}
          </div>
        )}

        {this.state.GSPage !== 0 && (
          <div
            className={'YJBackTop'}
            style={{ display: 'none' }}
            onClick={this.BackTop.bind(this)}
          >
            <div className={'YJBackTopIco'}> </div>
            <div className={'YJBackTopW'}>飞到顶部</div>
          </div>
        )}
        <Footer />
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default GS
